import React, { useState, useEffect, useRef, useCallback, memo } from 'react';

import { IconButton } from '../../../../helpers/IconButton';

const AgHeader = ({ column, setSort, api }) => {
  const [sorted, setSorted] = useState('');
  const headerRef = useRef(null);

  useEffect(() => {
    const handleSortChanged = () => {
      if (column.isSortAscending()) {
        setSorted('asc');
      } else if (column.isSortDescending()) {
        setSorted('desc');
      } else {
        setSorted('');
      }
    };

    column.addEventListener('sortChanged', handleSortChanged);
    handleSortChanged();

    return () => {
      column.removeEventListener('sortChanged', handleSortChanged);
    };
  }, [column]);

  const handleClick = useCallback(
    event => {
      if (column.colDef.onClick) {
        column.colDef.onClick(event, api);
      }
    },
    [column, api],
  );

  const handleSort = useCallback(
    event => {
      let newSort = '';

      if (sorted === '') {
        newSort = 'asc';
      } else if (sorted === 'asc') {
        newSort = 'desc';
      } else if (sorted === 'desc') {
        newSort = '';
      }
      setSort(newSort, event.shiftKey);
    },
    [sorted, setSort],
  );

  const { colDef } = column;

  let sortElements = null;
  let menuButton = null;
  let textElement = null;

  if (colDef.sortable) {
    if (sorted === 'asc') {
      sortElements = <i className="fa fa-caret-down" onClick={handleSort} />;
    } else if (sorted === 'desc') {
      sortElements = <i className="fa fa-caret-up" onClick={handleSort} />;
    }
    textElement = (
      <span className="mr5" onClick={handleSort}>
        {colDef.headerName}
      </span>
    );
  } else {
    textElement = <span className="mr5">{colDef.headerName}</span>;
  }

  if (colDef.onClick) {
    menuButton = (
      <IconButton className="mr5" icon="plus" onClick={handleClick} size="sm" title="Add" variant="primary" />
    );
  }

  return (
    <div ref={headerRef} className="ag-header-cell-label">
      {menuButton}
      {textElement}
      {sortElements}
    </div>
  );
};

export default memo(AgHeader);
